import { render, staticRenderFns } from "./version.vue?vue&type=template&id=4776d1a4&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4776d1a4')) {
      api.createRecord('4776d1a4', component.options)
    } else {
      api.reload('4776d1a4', component.options)
    }
    module.hot.accept("./version.vue?vue&type=template&id=4776d1a4&", function () {
      api.rerender('4776d1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/app/version.vue"
export default component.exports